import { IAuthToken } from '../../models';

export abstract class AuthTokenService {
  setToken?(token: IAuthToken): boolean;

  abstract getToken(): IAuthToken;

  clearAuthArtifacts?(): void;
}
